module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "notification-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.notification.title))]), _vm._v(" "), _c('small', {
    staticClass: "time pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notification.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.notification.body))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3198abf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NotificationItem.vue
// module id = 635
// module chunks = 1